module.exports = __webpack_public_path__ + "static/img/ziyuan_02.c194c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ziyuan_02.png
// module id = 7z6H
// module chunks = 0